import {
  applyGuestAddressMode,
  COMPANION_FIELD_ROWS_WITHOUT_ADDRESS,
  getGuestAddressMode,
  type CompanionFieldMode,
  type CompanionFieldsConfig,
} from "@/lib/companionFields";

interface OnlineBookingFieldModesEditorProps {
  fields: CompanionFieldsConfig;
  onChange: (fields: CompanionFieldsConfig) => void;
  canWrite: boolean;
  namePrefix: string;
}

export function OnlineBookingFieldModesEditor({
  fields,
  onChange,
  canWrite,
  namePrefix,
}: OnlineBookingFieldModesEditorProps) {
  return (
    <div className="min-w-0 max-w-full overflow-x-auto">
      <table className="w-full min-w-[20rem] text-left text-sm sm:min-w-[28rem]">
        <thead>
          <tr className="border-b border-separator text-label-secondary">
            <th className="py-2 pr-3 font-medium">Feld</th>
            <th className="px-2 py-2 font-medium">Aus</th>
            <th className="px-2 py-2 font-medium">Optional</th>
            <th className="px-2 py-2 font-medium">Pflicht</th>
          </tr>
        </thead>
        <tbody>
          <tr className="border-b border-separator/60">
            <td className="py-2 pr-3 text-label">
              Adresse
              <span className="mt-0.5 block text-xs font-normal text-label-secondary">
                Straße, PLZ, Ort und Land (ISO) werden gemeinsam gesteuert.
              </span>
            </td>
            {(["off", "optional", "required"] as CompanionFieldMode[]).map((mode) => (
              <td key={mode} className="px-2 py-2 text-center">
                <input
                  type="radio"
                  name={`${namePrefix}-address`}
                  className="h-4 w-4"
                  checked={getGuestAddressMode(fields) === mode}
                  onChange={() => onChange(applyGuestAddressMode(fields, mode))}
                  disabled={!canWrite}
                  aria-label={`Adresse: ${mode}`}
                />
              </td>
            ))}
          </tr>
          {COMPANION_FIELD_ROWS_WITHOUT_ADDRESS.map((row) => (
            <tr key={row.key} className="border-b border-separator/60">
              <td className="py-2 pr-3 text-label">{row.label}</td>
              {(["off", "optional", "required"] as CompanionFieldMode[]).map((mode) => (
                <td key={mode} className="px-2 py-2 text-center">
                  <input
                    type="radio"
                    name={`${namePrefix}-field-${row.key}`}
                    className="h-4 w-4"
                    checked={fields[row.key] === mode}
                    onChange={() => onChange({ ...fields, [row.key]: mode })}
                    disabled={!canWrite}
                    aria-label={`${row.label}: ${mode}`}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
